export default __webpack_public_path__ + "static/media/Constellation_003.e33ed427.jpg";